/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import DoubleTitle from './DoubleTitle/DoubleTitle';
import LargeImage from './LargeImage/LargeImage';
import LargeIntro from './LargeIntro/LargeIntro';
import Video from './Video/Video';
import SideImage from './SideImage/SideImage';
import BottomImage from './BottomImage/BottomImage';
import FullHeightHalfImage from './FullHeightHalfImage/FullHeightHalfImage';
import './Header.scss';

/**
 * This is the Header component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Header({ type, ...props }) {
  if (type === 'videoEntry') {
    return <Video {...props} />;
  }

  if (type === 'largeImage') {
    return <LargeImage {...props} />;
  }

  if (type === 'largeIntro') {
    return <LargeIntro {...props} />;
  }

  if (type === 'sideImage') {
    return <SideImage {...props} />;
  }

  if (type === 'bottomImage') {
    return <BottomImage {...props} />;
  }

  if (type === 'fullHeightHalfImage') {
    return <FullHeightHalfImage {...props} />;
  }

  return <DoubleTitle {...props} />;
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Header.propTypes = {
  type: PropTypes.oneOf([
    'doubleTitle',
    'largeImage',
    'largeIntro',
    'videoEntry',
    'sideImage',
    'bottomImage',
    'fullHeightHalfImage',
  ]).isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Header.defaultProps = {
  type: 'doubleTitle',
};

export default Header;
